import styled from "styled-components";
import LinkButton from "../LinkButton";

export const StripeFormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StripeElementWrapper = styled.div`
  min-height: 120px;
`;

export const StripeAmount = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.textSubtle};
  text-align: center;
  font-size: 14px;
`;

export const StripeEditButton = styled(LinkButton)`
  align-self: center;
`;
